
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/auth');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0056A6] via-[#0066CC] to-[#707070] flex items-center justify-center relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 right-16 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute top-1/2 right-8 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="text-center z-10">
        {/* Logo Container */}
        <div className="mb-8 animate-pulse">
          <div className="w-32 h-32 bg-white/10 rounded-3xl flex items-center justify-center mx-auto mb-6 backdrop-blur-sm border border-white/20">
            <div className="relative">
              <i className="ri-car-line text-6xl text-white"></i>
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#F9A826] rounded-full flex items-center justify-center">
                <i className="ri-navigation-line text-white text-xs"></i>
              </div>
            </div>
          </div>
        </div>

        {/* App Name */}
        <div className="mb-4">
          <h1 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
            موف برو
          </h1>
          <h2 className="text-xl font-medium text-white/90 mb-1">MovePro</h2>
          <p className="text-white/70 text-sm font-light">خدمات النقل الذكي</p>
        </div>

        {/* Animated Car Icon */}
        <div className="mb-8">
          <div className="flex items-center justify-center space-x-2 rtl:space-x-reverse">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>

        {/* Tagline */}
        <div className="text-center">
          <p className="text-white/80 text-sm font-light leading-relaxed max-w-xs mx-auto">
            تجربة نقل ذكية وموثوقة<br />
            في جميع أنحاء المملكة
          </p>
        </div>

        {/* Loading Indicator */}
        <div className="mt-12">
          <div className="w-16 h-1 bg-white/20 rounded-full mx-auto overflow-hidden">
            <div className="w-full h-full bg-gradient-to-r from-[#F9A826] to-white rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Bottom Branding */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <p className="text-white/60 text-xs">
          المملكة العربية السعودية
        </p>
      </div>
    </div>
  );
}
